module.exports = __webpack_public_path__ + "static/poster-236f6c87d84fb526b7f0862e0d349274.jpg";